<div>
  <app-header-bar></app-header-bar>
</div>

<div class="integration-main-container">
  <app-integration-sidebar-button class="integration-sidebar"></app-integration-sidebar-button>
  <div class="integration-content">
    <mat-card class="integration-section">
      <div class="page-title-row">
        <button
          mat-icon-button
          class="back-button"
          (click)="backToLayersCloned()"
          aria-label="Back to layers cloned"
        >
          <mat-icon class="back-icon">arrow_back</mat-icon>
        </button>
        <h1>Layer integration history</h1>
      </div>

      <!-- Selected Layer Information -->
      @if (selectedLayerCloned$()) {
        <div>
          <mat-card-header>
            <div class="section-title">
              <mat-icon mat-card-avatar>layers</mat-icon>
              <mat-card-title>Selected Layer</mat-card-title>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div>
              <p><strong>Layer Name:</strong> {{ selectedLayerCloned$()?.layerName }}</p>
              <p><strong>Layer Type:</strong> {{ selectedLayerCloned$()?.layerType }}</p>
              <p><strong>Repository:</strong> {{ selectedLayerCloned$()?.repo }}</p>
            </div>
          </mat-card-content>
        </div>
      }

      <div class="integration-history-card">
        <mat-card-header class="integration-history-header">
          <div class="section-title">
            <mat-icon mat-card-avatar>history</mat-icon>
            <mat-card-title>Integration History</mat-card-title>
          </div>
          @if (selectedLayerCloned$()) {
            <div class="integration-actions">
              <button
                matButton="outlined"
                [class.button-disabled]="(selectedLayerCloned$()?.errors?.length ?? 0) > 0"
                [disabled]="(selectedLayerCloned$()?.errors?.length ?? 0) > 0"
                (click)="
                  completeLayerIntegration(
                    selectedLayerCloned$()!.repo,
                    selectedLayerCloned$()!.layerType
                  )
                "
              >
                <mat-icon>layers</mat-icon>Layer Integration
              </button>

              <button matButton="filled" (click)="refreshLayerIntegrationHistory()">
                <mat-icon>
                  @if (isLoadingHistory$()) {
                    <mat-spinner diameter="24"></mat-spinner>
                  } @else {
                    refresh
                  }
                </mat-icon>
                Refresh
              </button>
            </div>
          }
        </mat-card-header>
        <mat-card-content>
          <div class="integration-table-scroll">
            <table mat-table [dataSource]="layerIntegration$() || []" [trackBy]="trackBy">
              <!-- Layer Integration Id Column -->
              <ng-container matColumnDef="integrationId" sticky>
                <th mat-header-cell *matHeaderCellDef>Id</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  {{ layerIntegration.id }}
                </td>
              </ng-container>

              <!-- Layer Integration Id Column -->
              <ng-container matColumnDef="integrationDate" sticky>
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  {{ formatExecutionDate(layerIntegration.repository.dateExecution) }}
                </td>
              </ng-container>

              <!-- Layer Repository Name Column -->
              <ng-container matColumnDef="integrationRepoName" sticky>
                <th mat-header-cell *matHeaderCellDef>Repository Name</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  {{ layerIntegration.repository.repoName }}
                </td>
              </ng-container>

              <!-- Integration Commit Hash Column -->
              <ng-container matColumnDef="integrationHashCommit">
                <th mat-header-cell *matHeaderCellDef>Hash Commit</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  @if (getUrlHashCommit(layerIntegration.repository.hashCommit); as commitUrl) {
                    <a [href]="commitUrl" target="_blank" rel="noopener noreferrer">
                      {{ layerIntegration.repository.hashCommit }}
                    </a>
                  } @else {
                    <span>{{ layerIntegration.repository.hashCommit }}</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="intoDb">
                <th mat-header-cell *matHeaderCellDef>Into DB</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  <span
                    class="status-step-span"
                    [class.success-style]="layerIntegration.intoDb === 'Success'"
                    [class.failed-style]="layerIntegration.intoDb === 'Failed'"
                    [class.not-processed-style]="layerIntegration.intoDb === 'Not processed'"
                  >
                    {{ layerIntegration.intoDb }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="statsPrecompute">
                <th mat-header-cell *matHeaderCellDef>Stats precompute</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  <span
                    class="status-step-span"
                    [class.success-style]="layerIntegration.statsPrecompute === 'Success'"
                    [class.failed-style]="layerIntegration.statsPrecompute === 'Failed'"
                    [class.not-processed-style]="
                      layerIntegration.statsPrecompute === 'Not processed'
                    "
                  >
                    {{ layerIntegration.statsPrecompute }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="geoserverTiff">
                <th mat-header-cell *matHeaderCellDef>Geoserver tiff</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  <span
                    class="status-step-span"
                    [class.success-style]="layerIntegration.geoserverTiff === 'Success'"
                    [class.failed-style]="layerIntegration.geoserverTiff === 'Failed'"
                    [class.not-processed-style]="layerIntegration.geoserverTiff === 'Not processed'"
                  >
                    {{ layerIntegration.geoserverTiff }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="geoserverPyramidTiff">
                <th mat-header-cell *matHeaderCellDef>Geoserver pyramid tiff</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  <span
                    class="status-step-span"
                    [class.success-style]="layerIntegration.geoserverPyramidTiff === 'Success'"
                    [class.failed-style]="layerIntegration.geoserverPyramidTiff === 'Failed'"
                    [class.not-processed-style]="
                      layerIntegration.geoserverPyramidTiff === 'Not processed'
                    "
                  >
                    {{ layerIntegration.geoserverPyramidTiff }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="deploymentGeoserver">
                <th mat-header-cell *matHeaderCellDef>Deployment geoserver</th>
                <td mat-cell *matCellDef="let layerIntegration">
                  <span
                    class="status-step-span"
                    [class.success-style]="layerIntegration.deploymentGeoserver === 'Success'"
                    [class.failed-style]="layerIntegration.deploymentGeoserver === 'Failed'"
                    [class.not-processed-style]="
                      layerIntegration.deploymentGeoserver === 'Not processed'
                    "
                  >
                    {{ layerIntegration.deploymentGeoserver }}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
            </table>
          </div>
          @if (layerIntegration$()?.length === 0) {
            <p class="no-data-info">No layer integration.</p>
          }
        </mat-card-content>
      </div>
    </mat-card>
  </div>
</div>
